import * as styles from "./IntroHeroWithPreHeading.module.scss";

import React from "react";
import CurvedBorderShallow from "../../../components/borders/CurvedBorderShallow";
import { Colours } from "../../../utils/colours";
import { IntroProps } from "../IntroToDisplay";

interface IntroHeroWithPreHeadingProps extends Omit<IntroProps, "introType"> {
	borderColour?: string;
}

export const IntroHeroWithPreHeading: React.FC<IntroHeroWithPreHeadingProps> =
	({ title, preHeading, borderColour = Colours.WHITE }) => {
		return (
			<div className={styles.herowithimagecontainer}>
				<div className={styles.topsectionouter}>
					<div className={styles.textcontainer}>
						{
							<div className={styles.preheading}>
								{preHeading && (
									<p className={styles.preheadingtext}>{preHeading}</p>
								)}
							</div>
						}
						<div className={styles.title}>
							<h1>{title}</h1>
						</div>
					</div>
				</div>
				<div className={styles.bordersection}>
					<CurvedBorderShallow
						className={styles.border}
						fill={borderColour}
						rotation={0}
					/>
				</div>
			</div>
		);
	};

export default IntroHeroWithPreHeading;
